export enum LoanStatus {
  // MANUALLY-SET statuses
  AccountCreated = "account_created",
  AuthPackageSigned = "auth_package_signed",
  DocumentCollection = "document_collection",
  ReadyForUW = "ready_for_uw",
  InBorrowerUnderwriting = "in_borrower_underwriting",
  ApplicationComplete = "application_complete",
  InProcessingUnderwriting = "in_processing_underwriting",
  PreFundingQcAudit = "pre_funding_qc_audit",
  SignOffByUw = "sign_off_by_uw",
  PrelimClosingStatementSent = "prelim_closing_statement_sent",
  ClosingPackageSent = "closing_package_sent",
  InClosing = "in_closing",
  Funded = "funded",
  ClosedLoanPurchased = "closed_loan_purchased",
  ServicerBrandingComplete = "servicer_branding_complete",
  PostClosing = "post_closing",
  Canceled = "canceled",

  // AUTOMATICALLY CALCULATED statuses
  CreditReportError = "credit_report_errors",
  CreditReportReceived = "credit_report_received",
  CreditPullAuthorized = "credit_pull_authorized",
}

export const orderedLoanStatus: LoanStatus[] = [
  LoanStatus.AccountCreated,
  LoanStatus.CreditPullAuthorized,
  LoanStatus.CreditReportError,
  LoanStatus.CreditReportReceived,
  LoanStatus.AuthPackageSigned,
  LoanStatus.DocumentCollection,
  LoanStatus.ReadyForUW,
  LoanStatus.InBorrowerUnderwriting,
  LoanStatus.ApplicationComplete,
  LoanStatus.InProcessingUnderwriting,
  LoanStatus.PreFundingQcAudit,
  LoanStatus.SignOffByUw,
  LoanStatus.ClosingPackageSent,
  LoanStatus.InClosing,
  LoanStatus.Funded,
  LoanStatus.PostClosing,
  LoanStatus.ClosedLoanPurchased,
  LoanStatus.ServicerBrandingComplete,
  LoanStatus.Canceled,
];

export const loanStatusOptions = [
  {
    value: LoanStatus.AccountCreated,
    label: "Account Created",
  },
  {
    value: LoanStatus.AuthPackageSigned,
    label: "Auth Package Signed",
  },
  {
    value: LoanStatus.DocumentCollection,
    label: "Document Collection",
  },
  {
    value: LoanStatus.ReadyForUW,
    label: "Ready for UW",
  },
  {
    value: LoanStatus.InBorrowerUnderwriting,
    label: "In Borrower Underwriting",
  },
  {
    value: LoanStatus.ApplicationComplete,
    label: "Application Complete",
  },
  {
    value: "initial_processing",
    label: "Initial Processing",
    deprecated: true,
  },
  {
    value: "initial_disclosure_package_sent",
    label: "Initial Disclosure Package Sent",
    deprecated: true,
  },
  {
    value: "initial_disclosure_package_received",
    label: "Initial Disclosure Package Received",
    deprecated: true,
  },
  {
    value: LoanStatus.InProcessingUnderwriting,
    label: "In Processing/Underwriting",
  },
  {
    value: LoanStatus.PreFundingQcAudit,
    label: "Pre-Funding QC Audit",
  },
  {
    value: LoanStatus.SignOffByUw,
    label: "Sign-Off by UW",
  },
  {
    value: "prelim_closing_statement_sent",
    label: "Prelim Closing Statement Sent",
    deprecated: true,
  },
  {
    value: "prelim_closing_statement_received",
    label: "Prelim Closing Statement Received",
    deprecated: true,
  },
  {
    value: "ready_for_closing",
    label: "Ready for Closing",
    deprecated: true,
  },
  {
    value: LoanStatus.ClosingPackageSent,
    label: "Closing Package Sent",
  },
  {
    value: LoanStatus.InClosing,
    label: "In Closing",
  },
  {
    value: "funding_requested",
    label: "Funding Requested",
    deprecated: true,
  },
  {
    value: LoanStatus.Funded,
    label: "Funded",
  },
  {
    value: "executed_closing_package_received",
    label: "Executed Closing Package Received",
    deprecated: true,
  },
  {
    value: "original_note_forwarded",
    label: "Original Note Forwarded",
    deprecated: true,
  },
  {
    value: "closed_loan_shipped",
    label: "Closed Loan Shipped",
    deprecated: true,
  },
  {
    value: "mers_registration_complete",
    label: "MERS Registration Complete",
    deprecated: true,
  },
  {
    value: LoanStatus.ClosedLoanPurchased,
    label: "Closed Loan Purchased",
  },
  {
    value: LoanStatus.ServicerBrandingComplete,
    label: "Servicer Branding Complete",
  },
  {
    value: "ledger_not_reconciled",
    label: "Ledger Not Reconciled",
    deprecated: true,
  },
  {
    value: "ledger_reconciled",
    label: "Ledger Reconciled",
    deprecated: true,
  },
  {
    value: "title_policy_received",
    label: "Title Policy Received",
    deprecated: true,
  },
  {
    value: "recorded_security_instrument_received",
    label: "Recorded Security Instrument Received",
    deprecated: true,
  },
  {
    value: LoanStatus.PostClosing,
    label: "Post-Closing",
  },
  {
    value: "post_closing_audit_deficiency",
    label: "Post-Closing Audit Deficiency",
    deprecated: true,
  },
  {
    value: "post_closing_audit_cured",
    label: "Post-Closing Audit Cured",
    deprecated: true,
  },
  {
    value: "cancellation_requested",
    label: "Cancellation Requested",
    deprecated: true,
  },
  {
    value: "cancellation_due_to_inactivity",
    label: "Cancellation Due to Inactivity",
    deprecated: true,
  },
  {
    value: LoanStatus.Canceled,
    label: "Canceled",
  },
  {
    value: LoanStatus.CreditReportReceived,
    label: "Credit Report Received (SET BY SYSTEM)",
  },
  {
    value: LoanStatus.CreditPullAuthorized,
    label: "Credit Pull Authorized (SET BY SYSTEM)",
  },
  {
    value: LoanStatus.CreditReportError,
    label: "Credit Report Error (SET BY SYSTEM)",
  },
];

export const loanStatusToStr = status => {
  const o = loanStatusOptions.find(option => option.value === status);
  return o ? o.label : status;
};
